export const STATUSCHANGED = "filters/statusChanged";